export default {
  posts: []
}
